import { createRef, h } from "preact";
import { useLayoutEffect } from "preact/hooks";

import TextAreaComponent from "../TextArea.jsx";

export default function TextArea(props) {
  const ref = createRef();

  useLayoutEffect(() => {
    M.AutoInit(ref.current.base);
  }, []);

  return (
    <TextAreaComponent
      ref={ref}
      id="question-suggested"
      name="answer"
      value={props.answer}
      info={props.options.helperText}
      error={props.error}
      label={props.options.label}
      onChange={props.onSelect}
    />
  );
}
